export default "__VITE_ASSET__zIZCvdZh__"